import { useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/main.css";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    company: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let temp = {};
    if (!form.name) temp.name = "Name is required";
    if (!form.email) temp.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      temp.email = "Invalid email";
    if (!form.phone) temp.phone = "Phone is required";
    if (!form.subject) temp.subject = "Subject is required";
    if (!form.company) temp.company = "Company name is required";
    if (!form.message) temp.message = "Message is required";

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    emailjs
      .send(
        "service_oinouso",
        "template_q2ddvur",
        {
          name: form.name,
          email: form.email,
          phone: form.phone,
          subject: form.subject,
          company: form.company,
          message: form.message
        },
        "iFKpDXg2dNOnxd7UX"
      )
      .then(
        () => {
          setSuccess(true);
          setForm({
            name: "",
            email: "",
            phone: "",
            subject: "",
            company: "",
            message: ""
          });
          setErrors({});
        },
        (error) => {
          console.error("EmailJS Error:", error);
          alert("Something went wrong. Please try again.");
        }
      )
      .finally(() => setLoading(false));
  };

  return (
    <>
      {/* ===== TOP BANNER ===== */}
      <section className="page-banner">
        <div className="banner-overlay">
          <h1>Contact Us</h1>
        </div>
      </section>

      {/* ===== CONTACT INFO BOXES ===== */}
      <section className="contact-info-section">
        <div className="contact-info-container">
          <div className="contact-info-box">
            <div className="icon">📍</div>
            <h3>Our Address</h3>
            <p>
              Oxford Exports<br />
              Suite 4 A The Monarch <br />
              PT Usha Road, India 682011
            </p>
          </div>

          <div className="contact-info-box">
            <div className="icon">📞</div>
            <h3>Call Us</h3>
            <p>+91 919895211011</p>
          </div>

          <div className="contact-info-box">
            <div className="icon">✉️</div>
            <h3>Email Us</h3>
            <p>subu@oxfordexports.in</p>
          </div>
        </div>
      </section>

      {/* ===== CONTACT FORM ===== */}
      <section className="contact-form-section">
        <div className="contact-form-wrapper">
          <h2>Get In Touch</h2>
          <p className="form-subtitle">
            Fill out the form below and we’ll respond shortly.
          </p>

          {success && (
            <div className="success-message">
              Thank you! Your message has been submitted.
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-grid">
              <input
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                className={errors.name ? "error-border" : ""}
              />
              <input
                name="email"
                placeholder="Your Email"
                value={form.email}
                onChange={handleChange}
                className={errors.email ? "error-border" : ""}
              />
              <input
                name="phone"
                placeholder="Phone Number"
                value={form.phone}
                onChange={handleChange}
                className={errors.phone ? "error-border" : ""}
              />
              <input
                name="subject"
                placeholder="Subject"
                value={form.subject}
                onChange={handleChange}
                className={errors.subject ? "error-border" : ""}
              />
            </div>

            <input
              name="company"
              placeholder="Company Name"
              value={form.company}
              onChange={handleChange}
              className={errors.company ? "error-border" : ""}
            />

            <textarea
              name="message"
              rows="5"
              placeholder="Your Message"
              value={form.message}
              onChange={handleChange}
              className={errors.message ? "error-border" : ""}
            ></textarea>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </section>
    </>
  );
}

export default Contact;
